import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import TopNavBar from "./TopNavBar";
import Sidebar from "./Sidebar";
import SubNavigationBar from "./SubNavigationBar";
import UserProfileContextBanner from "./UserProfileContextBanner";
import LeftPanelPersonal from "../pages/Admin/LeftPanelPersonal";
import "../styles/AppLayout.css";

function AppLayout({ children }) {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));
  const role = localStorage.getItem("userRole");
  const isAdmin = role === "1" || user?.role === "admin";
  const isGroupEditor = /^\/admin-groups\/[^/]+\/?$/.test(location.pathname);
  const isAdminUserEditor =
    /^\/edit-user\/[^/]+\/?$/.test(location.pathname) &&
    new URLSearchParams(location.search).get("source") === "admin-users";
  const isCompactAdminEditor = isGroupEditor || isAdminUserEditor;

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [actionCentreUser, setActionCentreUser] = useState(null);
  const [profileRefreshKey, setProfileRefreshKey] = useState(0);
  const closeSidebar = () => setSidebarOpen(false);

  useEffect(() => {
    const root = document.documentElement;
    const topNav = document.querySelector(".top-nav-bar");
    const subnav = document.querySelector(".subnav-container");

    const updateHeights = () => {
      const topNavHeight = topNav?.offsetHeight || 56;
      const subnavHeight = isAdmin && subnav ? subnav.offsetHeight : 0;
      root.style.setProperty("--top-nav-height", `${topNavHeight}px`);
      root.style.setProperty("--subnav-height", `${subnavHeight}px`);
    };

    updateHeights();

    const observer = new ResizeObserver(() => updateHeights());
    if (topNav) observer.observe(topNav);
    if (subnav) observer.observe(subnav);

    window.addEventListener("resize", updateHeights);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", updateHeights);
    };
  }, [isAdmin, sidebarOpen]);

  return (
    <>
      <TopNavBar onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
      {isAdmin && <SubNavigationBar sidebarOpen={sidebarOpen} user={user} />}

      <div style={{ display: "flex" }}>
        {isAdmin && sidebarOpen && (
          <button
            type="button"
            className="sidebar-backdrop"
            aria-label="Close sidebar"
            onClick={closeSidebar}
          />
        )}
        {isAdmin && <Sidebar isOpen={sidebarOpen} />}
        <div
          className={`app-layout-content ${isAdmin ? "with-admin-subnav" : ""} ${
            isCompactAdminEditor ? "compact-admin-editor" : ""
          }`}
          style={{
            marginLeft: isAdmin && sidebarOpen ? "180px" : "0px",
          }}
        >
          {isAdmin && !isCompactAdminEditor && (
            <UserProfileContextBanner
              sidebarOpen={sidebarOpen}
              refreshKey={profileRefreshKey}
              onOpenActionCentre={setActionCentreUser}
            />
          )}
          {children}
        </div>
      </div>
      {isAdmin && actionCentreUser && (
        <LeftPanelPersonal
          user={actionCentreUser}
          onClose={() => setActionCentreUser(null)}
          onSaved={() => setProfileRefreshKey((value) => value + 1)}
        />
      )}
    </>
  );
}

export default AppLayout;
